import { mutator } from 'satcheljs';
import { setAgendaMailEnabled } from 'owa-agenda-mail-option/lib/actions/internalActions';
import getStore from 'owa-agenda-mail-option/lib/store/store';

export const setAgendaMailEnabledMutator = mutator(setAgendaMailEnabled, actionMessage => {
    const { isEnabledToSet } = actionMessage;

    getStore().isAgendaMailEnabled = isEnabledToSet;
});
